import { SimpleForm, useRecordContext } from 'react-admin';
import { transformWorkerDetails } from '@/pages/Candidate/utils';
import { CreateStyled } from '@/styles/overrides';
import FormContent from './FormContent';
import { RequestCountyProps } from './types';

const RequestCounty = (props: RequestCountyProps) => {
  const record = useRecordContext();

  return (
    <CreateStyled title="Request County Criminal" {...props}>
      <SimpleForm
        defaultValues={() => transformWorkerDetails(record)}
        mode="onChange"
        reValidateMode="onChange"
        toolbar={false}
      >
        <FormContent {...props} />
      </SimpleForm>
    </CreateStyled>
  );
};

export default RequestCounty;
